// Prefer the credential/door provider so mixed-provider reports do not inherit
// another door's lifecycle. The hotel remains a fallback for legacy payloads.
export function schlageAccessState(access, hotel) {
  const lockType =
    access?.issuer?.lockType ||
    access?.lockType ||
    access?.door?.lockType ||
    hotel?.lockType;
  if ((lockType !== "schlage" && !access?.issuer) || !access?.keyboardPwd) return null;
  if (access.status === "pending" || access.pendingOperation) {
    if (access.commandError && !access.commandId) {
      return access.revocationRequested || access.pendingOperation === "delete"
        ? "removalUnconfirmed"
        : "unconfirmed";
    }
    return access.revocationRequested || access.pendingOperation === "delete"
      ? "deleting"
      : "pending";
  }
  if (access.status === "failed") return "failed";
  // Legacy imported records can lack status, but still require a provider ID.
  if (access.keyboardPwdId && (!access.status || access.status === "active")) {
    if (access.revocationRequested) return "deleteFailed";
    if (access.commandError) return "changeFailed";
    return "active";
  }
  return "unconfirmed";
}

export function hasPendingSchlageAccess(keys, hotel) {
  return (keys || []).some((key) =>
    ["pending", "deleting"].includes(schlageAccessState(key, hotel)),
  );
}

export function isInstalledSchlageAccess(state) {
  return ["active", "deleteFailed", "changeFailed"].includes(state);
}

// Deletion is a credential capability, independent of the hotel default.
export function hasRevocableAccess(reservation, hotel) {
  return [...(reservation.ekeys || []), ...(reservation.passcodes || [])].some(access => {
    const provider = access.issuer?.lockType || access.lockType || access.door?.lockType || hotel?.lockType || 'ttlock';
    return ['ttlock', 'schlage'].includes(provider) && !access.offline;
  });
}
